import type User from '~/types/auth/user'
import { MFANotSetupException, MFARequiredException } from '~/types/exceptions'

interface UserState {
  user?: User
  isAdmin?: boolean
}

export const useUserStore = () => {
  const { login, me, logout, isAdmin } = useUserApi()
  return defineStore('user', {
    state: (): UserState => {
      return {
        user: undefined,
        isAdmin: undefined,
      }
    },
    persist: true,
    actions: {
      async isAuthenticated() {
        try {
          await this.fetch()
          return true
        } catch (error) {
          if (error instanceof MFANotSetupException || error instanceof MFARequiredException) {
            throw error
          }
          return false
        }
      },
      async login(email: string, password: string) {
        await login(email, password)
        await this.fetch()
      },
      async fetch() {
        const user = await me()
        this.user = user
      },
      async logout() {
        try {
          await logout()
        } catch {
          // do nothing
        } finally {
          this.user = undefined
        }
      },
      async checkAdmin() {
        if (!this.isAdmin) {
          this.isAdmin = await isAdmin()
        }
        return this.isAdmin
      },
    },
  })()
}
